import { render, staticRenderFns } from "./Tab2Progress.vue?vue&type=template&id=48291621&scoped=true"
import script from "./Tab2Progress.vue?vue&type=script&lang=js"
export * from "./Tab2Progress.vue?vue&type=script&lang=js"
import style0 from "./Tab2Progress.vue?vue&type=style&index=0&id=48291621&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48291621",
  null
  
)

export default component.exports